const STATUS_EVENT = "orderly:network-status";

export const publishNetworkStatus = (online) => {
  window.dispatchEvent(new CustomEvent(STATUS_EVENT, { detail: { online: Boolean(online) } }));
};

export const subscribeNetworkStatus = (listener) => {
  const handler = (event) => listener(Boolean(event.detail?.online));
  window.addEventListener(STATUS_EVENT, handler);
  return () => window.removeEventListener(STATUS_EVENT, handler);
};
